import { useEffect, useRef } from "react"

/**
 * Makes an element `inert` while `active`: no focus, pointer or assistive
 * technology reaches it. Set on the DOM node because React 18 does not know
 * the attribute and the installed types expect a boolean it would not render.
 */
export const useInert = <T extends HTMLElement>(active: boolean) => {
  const ref = useRef<T>(null)
  useEffect(() => {
    ref.current?.toggleAttribute("inert", active)
  }, [active])
  return ref
}
